var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLuckyDrawIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6630_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 12C1.22464 12 0.800716 11.842 0.488155 11.5607C0.175595 11.2794 0 10.8978 0 10.5L0 1.5C0 1.10217 0.175595 0.720644 0.488155 0.43934C0.800716 0.158035 1.22464 0 1.66667 0H3.33333C3.33333 0.397824 3.50893 0.779355 3.82149 1.06066C4.13405 1.34196 4.55797 1.5 5 1.5C5.44203 1.5 5.86595 1.34196 6.17851 1.06066C6.49107 0.779355 6.66667 0.397824 6.66667 0H8.33333C8.77536 0 9.19928 0.158035 9.51184 0.43934C9.82441 0.720644 10 1.10217 10 1.5V10.5C10 10.8978 9.82441 11.2794 9.51184 11.5607C9.19928 11.842 8.77536 12 8.33333 12H6.66667C6.66667 11.6022 6.49107 11.2206 6.17851 10.9393C5.86595 10.658 5.44203 10.5 5 10.5C4.55797 10.5 4.13405 10.658 3.82149 10.9393C3.50893 11.2206 3.33333 11.6022 3.33333 12H1.66667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6630_777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyDrawIcon);
export default __webpack_public_path__ + "static/media/lucky-draw-icon.fe1cf4bf3b0cf698302620be91bbddd6.svg";
export { ForwardRef as ReactComponent };